import { createApp } from 'vue';
import Navbar from '../../components/backend/navbar.vue';

export default createApp({})
  .component('Navbar', Navbar)
  .mount('#backend-navigation');
